(() => {
  const requestedValue = 'Complimentary gift wrapping requested';

  class CartGiftWrap extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;
      this.checkbox.addEventListener('change', () => this.save());
    }

    setStatus(message) {
      const status = this.querySelector('[data-gift-wrap-status]');
      if (status) status.textContent = message;
    }

    async save() {
      const requested = this.checkbox.checked;
      this.checkbox.disabled = true;
      this.setStatus('Saving…');

      try {
        const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Gift wrapping': requested ? requestedValue : ''
            }
          })
        });

        if (!response.ok) throw new Error('Gift wrapping update failed');
        await response.json();

        document.querySelectorAll('cart-gift-wrap').forEach((component) => {
          const input = component.querySelector('input[type="checkbox"]');
          if (input) {
            input.checked = requested;
            input.disabled = false;
          }
          if (typeof component.setStatus === 'function') {
            component.setStatus(requested ? 'Complimentary gift wrapping added.' : 'Gift wrapping removed.');
          }
        });
      } catch (error) {
        this.checkbox.checked = !requested;
        this.checkbox.disabled = false;
        this.setStatus('We couldn’t save this choice. Please try again.');
      }
    }
  }

  if (!customElements.get('cart-gift-wrap')) {
    customElements.define('cart-gift-wrap', CartGiftWrap);
  }
})();
